import React, { useEffect, useState } from 'react';
import Item from '../../components/Form/Item';
import { Checkbox, Row, Col, message } from 'antd';
import { ErrorMessage, useFormikContext } from 'formik';
import axios from '../../util/Api';
import { LoadingOutlined } from '@ant-design/icons';

const TrainingCompetencyForm = (props) => {
  const formik = useFormikContext();
  const [loading, setLoading] = useState(true);
  const [competencies, setCompetencies] = useState([]);

  useEffect(() => {
    fetchCompetencies();
  }, []);

  const fetchCompetencies = () => {
    setLoading(true);
    const url = `/training-competency/list`;
    axios.get(url).then(({ data }) => {
      setCompetencies(data.competencies || []);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat daftar pelatihan");
      setLoading(false);
    });
  }

  const handleChange = (values) => {
    formik.setFieldValue("training_competency", values);
  }

  return (
    <Item name="Pelatihan yang pernah diikuti">
      <Checkbox.Group style={{width: "100%"}} defaultValue={formik.values.training_competency} onChange={handleChange}>
        {loading ? (
          <>
            <LoadingOutlined className="gx-mr-2" /> Sedang memuat daftar pelatihan
          </>
        ) : (
          <Row>
            {competencies.map((item, key)=>{
              return (
                <Col md={12} xs={24} key={`competency-${key}`}>
                  <div className="gx-mb-1">
                    <Checkbox value={item.id}>{item.name}</Checkbox>
                  </div>
                </Col>
              );
            })}
          </Row>
        )}
      </Checkbox.Group>
      <ErrorMessage component="div" name="training_competency" className="gx-mt-2 gx-text-red" />
    </Item>
  );
}

export default TrainingCompetencyForm;